module.exports = __webpack_public_path__ + "static/media/YFI.40884925.svg";